exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider-panel--2tlrQudAmTgDuryD4dPedb {\n  display: flex;\n  flex-direction: column;\n  row-gap: .5rem;\n}\n", ""]);

// exports
exports.locals = {
	"sharePanelFieldContainer": "provider-panel--2tlrQudAmTgDuryD4dPedb",
	"sharePanelFieldContainer": "provider-panel--2tlrQudAmTgDuryD4dPedb"
};